import { createAction, props } from '@ngrx/store';

import type { FileItem } from '@app/types/file-item.type';

export const NAVIGATE_TO_ITEM = '[Browse Target] Navigate to item';
export const CLEAR_NAVIGATION = '[Browse Target] Clear navigation';
export const LOAD_FOLDERS = '[Browse Target] Load folders';
export const LOAD_FOLDERS_SUCCESS = '[Browse Target] Load folders success';
export const LOAD_FOLDERS_FAIL = '[Browse Target] Load folders fail';

export const RESET_STATE = '[Browse Target] Reset state';

export const navigateToItem: any = createAction(NAVIGATE_TO_ITEM, props<{ folder: FileItem }>());

export const clearNavigation: any = createAction(CLEAR_NAVIGATION);

export const loadFolders: any = createAction(LOAD_FOLDERS, props<{ parent: FileItem }>());

export const loadFoldersSuccess: any = createAction(
  LOAD_FOLDERS_SUCCESS,
  props<{ list: FileItem[] }>(),
);

export const loadFoldersFail: any = createAction(LOAD_FOLDERS_FAIL, props<{ error: string }>());

export const resetBrowseTargetState: any = createAction(RESET_STATE);
